// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3cYkJ","colBig":"styles_colBig__3zq88","colSmall":"styles_colSmall__1psue"};